import { Box, Button, Flex, Heading, HStack, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { TrainingContainer } from '../components/LandingPageComponents/styles/SplashStyles';
import { useScreenWidth } from 'hooks/useScreenWidth';

const Training = () => {
    const navigate = useNavigate();
    const screen = useScreenWidth();

    return (
        <TrainingContainer>
            <HStack justify="end" px="17px" alignItems="center">
                <Text color="#979C9E" fontSize="18px" lineHeight="18px">
                    Skip
                </Text>
            </HStack>
            <Flex w="full" h="full" justify="space-between" alignItems="center" flexDir="column">
                <Box w="90%">
                    <Text
                        color="#090A0A"
                        mt="25px"
                        textAlign="center"
                        fontSize="24px"
                        lineHeight="16px">
                        Obana Certification
                    </Text>
                    <Heading
                        as="h2"
                        mt="25px"
                        mb="26px"
                        color="#090A0A"
                        textAlign="center"
                        fontSize="32px"
                        lineHeight="36px">
                        Let’s Start Your Training{' '}
                    </Heading>
                </Box>

                <Button
                    mb="5.5rem"
                    w="90%"
                    mx="auto"
                    fontWeight="500"
                    borderRadius="48px"
                    color="#090A0A"
                    onClick={() =>
                        navigate(
                            screen > 500 ? '/dashboard/complete-training' : '/complete-training',
                            {
                                replace: true,
                            },
                        )
                    }>
                    Begin Training
                </Button>
            </Flex>
        </TrainingContainer>
    );
};

export default Training;
